import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { fetchGetFoldersForOffer } from '../repositories/favorites/v1/get-folders-for-offer';
import { setFolders, setListLoading, setSelected } from '../actions';
import { mapGetFoldersForOfferResponse } from '../mappers';
import { selectFolders, selectSelectedIds } from '../selectors';
export var getFoldersForOffer = function getFoldersForOffer(_ref) {
  var offerId = _ref.offerId,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? 40 : _ref$limit,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 0 : _ref$offset,
    keepExisting = _ref.keepExisting;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref2) {
      var httpApi, logger, parameters, _yield$fetchGetFolder, statusCode, response, existingFolders, existingSelectedFolders, _mapGetFoldersForOffe, folders, selectedFolders, canLoadMore;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            httpApi = _ref2.httpApi, logger = _ref2.logger;
            parameters = {
              limit: limit,
              offset: offset,
              offerId: offerId
            };
            _context.prev = 2;
            dispatch(setListLoading({
              isLoading: true
            }));
            _context.next = 6;
            return fetchGetFoldersForOffer({
              httpApi: httpApi,
              parameters: parameters
            });
          case 6:
            _yield$fetchGetFolder = _context.sent;
            statusCode = _yield$fetchGetFolder.statusCode;
            response = _yield$fetchGetFolder.response;
            if (statusCode === 200) {
              existingFolders = [];
              existingSelectedFolders = {};
              if (keepExisting) {
                existingFolders = selectFolders(getState()) || [];
                existingSelectedFolders = selectSelectedIds(getState()) || {};
              }
              _mapGetFoldersForOffe = mapGetFoldersForOfferResponse(response), folders = _mapGetFoldersForOffe.folders, selectedFolders = _mapGetFoldersForOffe.selectedFolders, canLoadMore = _mapGetFoldersForOffe.canLoadMore;
              dispatch(setFolders({
                folders: [].concat(_toConsumableArray(existingFolders), _toConsumableArray(folders)),
                canLoadMore: canLoadMore
              }));
              dispatch(setSelected({
                selectedFolders: _objectSpread(_objectSpread({}, existingSelectedFolders), selectedFolders)
              }));
            }
            dispatch(setListLoading({
              isLoading: false
            }));
            _context.next = 17;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](2);
            dispatch(setListLoading({
              isLoading: false
            }));
            logger.error(_context.t0, {
              description: 'Fail to get favorites folders'
            });
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 13]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};